import { render, staticRenderFns } from "./BasePaginator.vue?vue&type=template&id=13e09502"
import script from "./BasePaginator.vue?vue&type=script&lang=js"
export * from "./BasePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports